import './PlayNextPreview.css';
import React, { useEffect, useState, useMemo } from 'react';
import { useFilteredPrioritizedGames } from '../../../../../../shared/src/hooks/use-filtered-prioritized-games.hook';
import { useSelector } from 'react-redux';
import { Image } from '../../../../../../shared/src/components/Image';
import { useNeoCmsFeatureRelatedGamesHook } from '../../../../../../shared/src/hooks/use-neo-cms-feature-related-games.hook';
import { NeoCmsGameCategoryFeatureNamesEnum } from '../../../../../../shared/src/enums/neo-cms-game-category-feature-names.enum';

export const PlayNextPreview = () => {
    const { gamesById } = useSelector((state) => (state.casino));
    const { isNeoCmsIntegrationEnabled } = useSelector((state) => state.app);
    let { presentPrioritizedGamesOnBrand } = useFilteredPrioritizedGames();
    const [gamesToShow, setGamesToShow] = useState(null);
    const featureName = NeoCmsGameCategoryFeatureNamesEnum.PLAY_NEXT_IN_GAME_PAGE;
    const { featureRelatedGames } = useNeoCmsFeatureRelatedGamesHook(featureName);

    const prioritizedGamesOnBrand = useMemo(() => {
        return isNeoCmsIntegrationEnabled
            ? featureRelatedGames.map(game => game.id)
            : presentPrioritizedGamesOnBrand;
    }, [isNeoCmsIntegrationEnabled, featureRelatedGames, presentPrioritizedGamesOnBrand]);

    useEffect(() => {
        if (gamesById && Array.isArray(prioritizedGamesOnBrand) && prioritizedGamesOnBrand.length > 0) {
            const prioritizedGamesSlice = prioritizedGamesOnBrand.slice(0, 3);
            setGamesToShow(prioritizedGamesSlice.map((gameId) => (gamesById[gameId])));
        }
    }, [prioritizedGamesOnBrand, gamesById]);

    if (!gamesToShow) {
        return null;
    }

    return (
        <div className="header-play-next-preview">
            {gamesToShow.map(game => <Image
                key={game.id}
                className="header-play-next-preview__game-img"
                images={game.images}
            />)}
        </div>
    );
};
